import { useRef } from "react";

import ComplementaryForm from "./forms";

const InventoryIncreaseReceipt = ({
  amount,
  bankAccounts,
  loading,
  trxUuid,
  onFinish,
}) => {
  const formRef = useRef();

  return (
    <div className="pt-8">
      <ComplementaryForm
        bankAccounts={bankAccounts}
        data={{ amount }}
        formRef={formRef}
        loading={loading}
        trxUuid={trxUuid}
        onFinish={onFinish}
      />
    </div>
  );
};
export default InventoryIncreaseReceipt;
